import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {StoreModule} from '@ngrx/store';

import {AppComponent} from './app.component';
import {ROUTES, RoutingModule} from './routing/routing.module';
import {pageDataReducer} from './store/reducers/page-data.reducer';
import {appSettingsReducer} from './store/reducers/app-settings.reducer';
import {patientsReducer} from './store/reducers/patients.reducer';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {ToastrModule} from 'ngx-toastr';
import {RequestService} from './services/request.service';
import {ErrorHandler} from './errors/error_handler';
import {RequestInterceptor} from './errors/http_interceptor';
import {UrlService} from './services/url.service';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {LoadingBarModule} from '@ngx-loading-bar/core';
import {UserService} from './services/user.service';
import {MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {OWL_DATE_TIME_LOCALE} from 'ng-pick-datetime';
import {DatepickerServiceService} from './services/datepicker-service.service';
import {SupervisorsocketService} from './services/supervisorsocket.service';
import {SocketIoConfig} from 'ngx-socket-io';
import {SharedModule} from './pages/mods/shared.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpLoaderFactory} from './pages/mods/Http_loader_factory';
import {EnvServiceProvider} from './services/env.service.provider';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {OrabankSdkService} from './services/orabank-sdk.service';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';

const config: SocketIoConfig = {url: 'api.creditemoi.local/', options: {}};

/*
translate loader functio
 */

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(ROUTES, {relativeLinkResolution: 'legacy'}),
    StoreModule.forRoot({
      pageData: pageDataReducer,
      appSettings: appSettingsReducer,
      patients: patientsReducer
    }),

    RoutingModule,
    // PagesModule,
    ToastrModule.forRoot(),
    LoadingBarHttpClientModule,
    // LoadingBarHttpModule,
    LoadingBarHttpClientModule,
    LoadingBarModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient]}
    }),
    // TranslateLoader,
    // TranslateHttpLoader
  ],
  exports: [],
  providers: [RequestService, UrlService, UserService, DatepickerServiceService,
    SupervisorsocketService, EnvServiceProvider, OrabankSdkService,
    {provide: LocationStrategy, useClass: HashLocationStrategy}, ErrorHandler,
    {provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true},
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: true}},
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {float: 'float'}},
    {provide: STEPPER_GLOBAL_OPTIONS, useValue: {showError: false}},
    {provide: OWL_DATE_TIME_LOCALE, useValue: 'fr'},
    // {
    //   provide: MAT_RADIO_DEFAULT_OPTIONS,
    //   useValue: { color: 'warn' },
    // },
    // {
    //   provide: STEPPER_GLOBAL_OPTIONS, useValue: {color: 'warn'}
    // }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {
}
